var render = function render(){var _vm=this,_c=_vm._self._c;return _c('environmental-allergies-template',{attrs:{"environmental-allergies":_vm.environmentalAllergies,"other-environmental-allergies":_vm.otherEnvironmentalAllergies,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }